import { createMuiTheme } from "@material-ui/core/";

const theme = createMuiTheme({
  palette: {
    primary: {
      light: "#2699fb",
      main: "#31394e",
      dark: "#222736",
      contrastText: "#f5f5f5",
      error: "#ea0101",
      warning: "#e8a101",
      success: "#00aa1e"
    },
    info: {
      main: "#1976d2"
    },
    secondary: {
      light: "#EE5100",
      main: "#E10000",
      dark: "#EE5122",
      contrastText: "#f5f5f5"
    },
    background: {
      default: "#f5f5f5",
      paper: "#ffffff"
    },
    textLight: "#f5f5f5",
    orange: "#EE5122",
    red: "#E10000",
    navBarButton: {
      hoverBG: "rgba(255, 255, 255, 0.3)"
    },
    hoverBG: "rgba(0, 0, 0, 0.1)"
  },
  sizes: {
    navBarWidth: 200,
    loginFormWidth: 444
  }
});

export default theme;
